export class MerchantSciId {
    merchantId: number;
    sci : string;
}
